import { useApiClient } from '@eluve/api-client-provider';
import { SupportedPdfTypes } from '@eluve/api-contract';

export const useGetFilePdfUrl = ({
  appointmentId,
  tenantId,
  type,
}: {
  appointmentId: string;
  tenantId: string;
  type: SupportedPdfTypes;
}) => {
  const api = useApiClient();
  return () =>
    api.appointments.getOrCreatePdfUrl({
      params: {
        tenantId,
        appointmentId,
      },
      body: {
        type,
      },
    });
};
